<template>
  <div class="box" ref="comWrapper">
    <div
      class="cover"
      v-show="chooseFlag"
      @click="chooseFlag = false"
      @touchmove.prevent
    ></div>
    <div
      class="quaCover"
      v-show="quaFlag"
      @click="quaFlag = false"
      @touchmove.prevent
    >
      <div class="queBox">
        <div>
          实名认证后即可佩带认证徽章
        </div>
        <div>
          <span @click.stop="quaFlag = false">暂时忽略</span>
          <span>|</span>
          <span @click.stop="toQua">立即认证</span>
        </div>
      </div>
      <img src="http://cdn.yxvzb.com/WEB/wx-master/images/star.png" />
    </div>
    <div class="sBox">
      <div class="comNum">
        <span class="indexCount">提问区</span>
        <div>
          <img
            @click="signIn"
            src="https://cdn.yxvzb.com/newWechat/image/%E7%AD%BE%E5%88%B0@2x.png"
            alt=""
          />
          <span @click="signIn">{{ isSignIn ? '已签到' : '签到' }}</span>
        </div>
        <!-- <span class="icon iconfont" :class="[chooseFlag?'icon-arrowup':'icon-arrowdown']" @click='chooseFlag?chooseFlag=false:chooseFlag=true'></span>
        <span class="indexName" @click='chooseFlag?chooseFlag=false:chooseFlag=true'>{{commentNameList[commentNameIndex]}}</span> -->
      </div>

      <!-- <div class="chooseFlag" v-show='chooseFlag'>
        <div @click='changeType(0)' :class='[commentNameIndex==0?"selected":""]'>
          <span class="icon iconfont icon-right selected" :class='[commentNameIndex==0?"selected":"hide"]'></span>
          按时间
        </div>
        <div @click='changeType(1)' :class='[commentNameIndex==1?"selected":""]'>
          <span class="icon iconfont icon-right selected" :class='[commentNameIndex==1?"selected":"hide"]'></span>
          按推荐
        </div>
      </div> -->
    </div>
    <ul ref="pinglunqu" class="ulBox ulBox2" @touchmove="loadMoreCallBack">
      <li
        v-if="commentContentList.length != 0"
        class="comConLi"
        v-for="(item, index) in commentContentList"
        :key="index"
      >
        <div class="zanBox">
          <img
            :src="[
              item.isLike == '1'
                ? 'http://cdn.yxvzb.com/WEB/wx-master/images/zan.png'
                : 'http://cdn.yxvzb.com/WEB/wx-master/images/notZan.png'
            ]"
            @click="like(item)"
          />
          <span>{{ item.likeCount > 99 ? '99+' : item.likeCount }}</span>
        </div>
        <div v-if="item.commentRendType == 1" style="display:flex;">
          <img :src="item.headPhoto" class="comUserPh" />
          <div class="comUserCon" @click="clickReplay(item)">
            <div class="comUserNZ">
              <span v-if="item.replyIsAuth" class="comUserName hasReplyIsAuth">
                {{ item.replyUserName }}
              </span>
              <span v-else class="comUserName">{{ item.replyUserName }}</span>
            </div>
            <div class="comTime">
              {{ item.createTime | transMonthLine }}
            </div>
            <div @click="" class="comCT" v-if="item.replyVoiceTime">
              <div
                class="audioDiv"
                v-if="!item.beReplyUserName && !item.beReplyUserId"
                @click.stop="audioPlay($event)"
              >
                <div class="voice-animate">
                  <div class="small"></div>
                  <div class="middle"></div>
                  <div class="large"></div>
                </div>
                <div>{{ item.replyVoiceTime }}</div>
                <audio :src="item.replyMediaId"></audio>
              </div>
              <div v-else>
                <span>回复</span>
                <span class="comCTN">@{{ item.beReplyUserName }}</span>
                <span>:</span>
                <div @click="" class="audioDiv" @click.stop="audioPlay($event)">
                  <div class="voice-animate">
                    <div class="small"></div>
                    <div class="middle"></div>
                    <div class="large"></div>
                  </div>
                  <div>{{ item.replyVoiceTime }}</div>
                  <audio :src="item.replyMediaId"></audio>
                </div>
                <div
                  v-if="item.beReplayIsDelete == 1"
                  class="comCTF comRemoveDiv"
                  style="color: #CC3333;text-align: center"
                >
                  此评论已删除
                </div>
                <div v-else>
                  <div
                    class="comCTF"
                    v-if="!item.beReplyVoiceTime && !item.beReplyMediaId"
                  >
                    <span class="comCTN">@{{ item.beReplyUserName }}</span>
                    :{{ item.beReplyContent }}
                  </div>
                  <div @click="" class="comCTF" v-else>
                    <span class="comCTN">@{{ item.beReplyUserName }}</span>
                    :
                    <div class="audioDiv" @click.stop="audioPlay($event)">
                      <div class="voice-animate">
                        <div class="small"></div>
                        <div class="middle"></div>
                        <div class="large"></div>
                      </div>
                      <div>{{ item.beReplyVoiceTime }}</div>
                      <audio :src="item.beReplyMediaId"></audio>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="comCT" v-else>
              <span v-if="!item.beReplyUserName && !item.beReplyUserId">
                {{ item.content }}
              </span>
              <div v-else>
                <span class="comCTN">@{{ item.beReplyUserName }}</span>
                :{{ item.content }}
                <div
                  v-if="item.beReplyDelFlag == 1"
                  class="comCTF comRemoveDiv"
                  style="color: #CC3333;text-align: center"
                >
                  此评论已删除
                </div>
                <div v-else>
                  <div
                    class="comCTF"
                    v-if="!item.beReplyVoiceTime && !item.beReplyMediaId"
                  >
                    <span class="comCTN">@{{ item.beReplyUserName }}:</span>
                    <span>{{ item.beReplyContent }}</span>
                  </div>
                  <div @click="" class="comCTF" v-else>
                    <span class="comCTN">@{{ item.beReplyUserName }}</span>
                    :
                    <div class="audioDiv" @click.stop="audioPlay($event)">
                      <div class="voice-animate">
                        <div class="small"></div>
                        <div class="middle"></div>
                        <div class="large"></div>
                      </div>
                      <div>{{ item.beReplyVoiceTime }}</div>
                      <audio :src="item.beReplyMediaId"></audio>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="giftCommentBox">
          {{ item.userName }}送给老师{{
            item.giftCount == 1 ? '一' : item.giftCount
          }}个{{ item.giftName }}
        </div>
      </li>
    </ul>
    <div v-show="btmFlag" class="btmBox" @click="goBtm">
      回到底部
    </div>
    <div class="footer">
      <img
        @click="goQua"
        :src="[
          ifQua
            ? 'https://cdn.yxvzb.com/WEB/wx-master/images/vvv.png'
            : 'https://cdn.yxvzb.com/WEB/wx-master/images/v.png'
        ]"
      />
      <input
        style="padding: 0 .2rem"
        type="text"
        ref="replyInput"
        placeholder="向讲师提问"
        v-model.trim="replyValue"
        @keyup.enter="sendReply"
        @click="initInput"
        @focus="focusInput"
        :class="[type == 6 ? 'short' : 'long']"
        @blur="scrollToTop"
      />
      <img
        src="//cdn.yxvzb.com/WEB/wx-master/images/face.png"
        @click="isUseEmoji"
      />
      <img
        v-if="type == 6"
        v-show="!sendFlag"
        :src="[
          isCollection
            ? 'http://cdn.yxvzb.com/newWechat/image/%E4%B8%AA%E4%BA%BA%E4%B8%AD%E5%BF%83-%E6%88%91%E7%9A%84%E6%94%B6%E8%97%8F@2x.png'
            : 'http://cdn.yxvzb.com/newWechat/image/%E6%94%B6%E8%97%8F@2x.png'
        ]"
        @click="collection"
      />
      <span
        v-show="!sendFlag"
        class="icon iconfont icon-fenxiang"
        @click="shareFlag = true"
      ></span>
      <div class="sendBox" v-show="sendFlag" @click="sendReply">
        发送
      </div>
      <emoji
        v-show="isOpenEmoji"
        @sendFatherEmoji="getEmoji"
        @deleteFatherEmoji="deleteEmoji"
      ></emoji>
    </div>
    <div
      v-show="shareFlag"
      @touchmove.prevent
      @click="shareFlag = false"
      class="shareCover"
    >
      <img src="http://cdn.yxvzb.com/img/share-it.png" />
      <p>
        点击分享
        <br />
        邀请更多的人一同观看
      </p>
    </div>
  </div>
</template>
<script>
import index from './comment';
export default index;
</script>
<style lang="less" scoped="">
@import './comment.less';
</style>
